import { render, staticRenderFns } from "./PhoneFooter.vue?vue&type=template&id=3b083501&scoped=true&"
import script from "./PhoneFooter.vue?vue&type=script&lang=js&"
export * from "./PhoneFooter.vue?vue&type=script&lang=js&"
import style0 from "./PhoneFooter.vue?vue&type=style&index=0&id=3b083501&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b083501",
  null
  
)

export default component.exports